<template>
  <router-view />
</template>

<script>

export default {
  name: 'ProjectWrapper'
}
</script>
